import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import Logo from './assets/logo.svg';
import LinkedinLogo from './assets/Linkedin_white.svg';
import TwitterLogo from './assets/Twitter_white.svg';
import MinisterioLogo from './assets/footer_logo_ministerio.png';
import InnoLogo from './assets/footer_logo_innoEnergy.png';
import { VSpacer } from '..';

var styles = function styles(theme) {
  return {
    footerContainer: {
      backgroundColor: '#58606A'
    },
    white: {
      color: 'white'
    },
    logo: {
      width: '155px'
    },
    link: {
      color: 'white',
      cursor: 'pointer',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      opacity: .8,
      '&:hover': {
        opacity: 1
      }
    },
    socialMediaImage: {
      width: '29px',
      height: '29px',
      padding: '5px'
    },
    sponsorsImage: {
      margin: '12px',
      marginRight: '48px'
    }
  };
};

var Footer =
/*#__PURE__*/
function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Footer);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Footer)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.copyrightpanel = function () {
      var classes = _this.props.classes;
      return React.createElement(Grid, {
        item: true,
        md: 6,
        sm: 12
      }, React.createElement(Grid, {
        container: true,
        direction: 'column'
      }, React.createElement('img', {
        src: Logo,
        className: classes.logo,
        alt: 'SmartMonkey Scalable Computing S.L.'
      }), React.createElement(VSpacer, {
        small: true
      }), React.createElement(Grid, {
        container: true
      }, React.createElement('a', {
        href: 'https://es.linkedin.com/company/smartmonkey'
      }, React.createElement('img', {
        src: LinkedinLogo,
        className: classes.socialMediaImage,
        alt: 'Visit us on LinkedIn'
      })), React.createElement('a', {
        href: 'https://twitter.com/smartmonkey_io'
      }, React.createElement('img', {
        src: TwitterLogo,
        className: classes.socialMediaImage,
        alt: 'Visit us on Twitter'
      }))), React.createElement(VSpacer, {
        medium: true
      }), React.createElement(Typography, {
        className: classes.white
      }, 'SmartMonkey Scalable Computing S.L.', React.createElement('br', null)), React.createElement(Typography, {
        className: classes.white
      }, '\xA9 2014-2019 All rights reserved'), React.createElement(VSpacer, {
        small: true
      }), React.createElement(Typography, {
        className: classes.white
      }, 'WITH ', React.createElement('span', {
        role: 'img',
        'aria-label': 'Love',
        style: {
          color: '#c23b22',
          fontSize: '16px'
        }
      }, "\u2764\uFE0F"), ' FROM BARCELONA'), React.createElement(VSpacer, null), React.createElement(VSpacer, null)));
    }, _this.linkspanel = function () {
      var _this$props = _this.props,
          classes = _this$props.classes,
          firstColumn = _this$props.firstColumn,
          secondColumn = _this$props.secondColumn,
          thirdColumn = _this$props.thirdColumn,
          fourthColumn = _this$props.fourthColumn;
      return React.createElement(Grid, {
        item: true,
        md: 6,
        sm: 12
      }, React.createElement(Grid, {
        container: true
      }, React.createElement(Grid, {
        item: true,
        md: 3,
        sm: 6,
        xs: 12
      }, React.createElement(Grid, {
        container: true,
        direction: 'column'
      }, firstColumn && firstColumn.map(function (link) {
        return React.createElement(Typography, {
          key: 'footer-link-' + link.text,
          className: classes.link,
          onClick: link.actionHandler
        }, link.text);
      }))), React.createElement(Grid, {
        item: true,
        md: 3,
        sm: 6,
        xs: 12
      }, React.createElement(Grid, {
        container: true,
        direction: 'column'
      }, secondColumn && secondColumn.map(function (link) {
        return React.createElement(Typography, {
          key: 'footer-link-' + link.text,
          className: classes.link,
          onClick: link.actionHandler
        }, link.text);
      }))), React.createElement(Grid, {
        item: true,
        md: 3,
        sm: 6,
        xs: 12
      }, React.createElement(Grid, {
        container: true,
        direction: 'column'
      }, thirdColumn && thirdColumn.map(function (link) {
        return React.createElement(Typography, {
          key: 'footer-link-' + link.text,
          className: classes.link,
          onClick: link.actionHandler
        }, link.text);
      }))), React.createElement(Grid, {
        item: true,
        md: 3,
        sm: 6,
        xs: 12
      }, React.createElement(Grid, {
        container: true,
        direction: 'column'
      }, fourthColumn && fourthColumn.map(function (link) {
        return React.createElement(Typography, {
          key: 'footer-link-' + link.text,
          className: classes.link,
          onClick: link.actionHandler
        }, link.text);
      })))));
    }, _temp));
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          compact = _this$props2.compact;
      return React.createElement(Grid, {
        container: true,
        className: classes.footerContainer,
        justify: 'center'
      }, !compact && React.createElement(Grid, {
        item: true,
        xl: 6,
        md: 8,
        sm: 12
      }, React.createElement(Grid, {
        container: true,
        direction: 'column'
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(VSpacer, null)), React.createElement(Grid, {
        container: true,
        direction: 'row'
      }, this.copyrightpanel(), this.linkspanel()), React.createElement(Typography, {
        className: classes.white
      }, 'Project supported by:'), React.createElement(Grid, {
        container: true,
        alignItems: 'center'
      }, React.createElement(Grid, {
        item: true,
        className: classes.sponsorsImage
      }, React.createElement('a', {
        href: 'http://www.innoenergy.com/'
      }, React.createElement('img', {
        src: InnoLogo,
        alt: 'InnoEnergy'
      }))), React.createElement(Grid, {
        item: true,
        className: classes.sponsorsImage
      }, React.createElement('img', {
        src: MinisterioLogo,
        alt: 'Ministerio de industria'
      }))), React.createElement(VSpacer, {
        large: true
      }), React.createElement(VSpacer, {
        large: true
      }))), ' ', compact && React.createElement(Grid, {
        item: true,
        md: 10,
        sm: 12
      }, React.createElement(Grid, {
        container: true,
        direction: 'column'
      }, React.createElement(VSpacer, {
        large: true
      }), React.createElement(Typography, {
        className: classes.white
      }, 'SmartMonkey Scalable Computing S.L.', React.createElement('br', null)), React.createElement(Typography, {
        className: classes.white
      }, '\xA9 2014-2019 All rights reserved'), React.createElement(VSpacer, {
        large: true
      }))));
    }
  }]);

  return Footer;
}(Component);

export default withStyles(styles)(Footer);